/**
 * @author yan st
 * @date 2022-08-16 08:40
 * @Description:
 */
import {qspost} from '@/plugins/axios'

/*
*   账号登录
* */
export const organLogin = (username,password,code,key) => qspost('/api/Organ/organLogin', {username,password,code,key})

/*
*  获取图片验证码
* */
export const verify = () => qspost('/verify', {})

/*
*  获取手机号验证码
* */
export const getPhoneCode = (phone) => qspost('/code', {phone})


/*
*  注册
* */
export const organRegister = (
  username,password,organ_name,phone,code,key
) => qspost('/api/Organ/organRegister', {
  username,password,organ_name,phone,code,key
})

/*
* 找回密码
* */
export const forgetPassword = (
  organ_name,username,phone,code,password
) => qspost('/api/Organ/forgetPassword', {
  organ_name,username,phone,code,password
})













